import React, { useState } from "react";
import { toast } from "react-toastify";

const CopyableText = ({ label = "Texto", text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(`${label} copiado com sucesso!`);
    } catch (err) {
      toast.error(`Falha ao copiar ${label}. Tente novamente.`);
    }
  };

  return (
    <span
      onClick={handleCopy}
      style={{
        cursor: "pointer",
        color: copied ? "#800080" : "#525F7F",
        transition: "color 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.textDecoration = "underline";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.textDecoration = "none";
      }}
      title={copied ? "Texto Copiado!" : "Clique para copiar"}
    >
      {text}
    </span>
  );
};

export default CopyableText;
